import { render, staticRenderFns } from "./stationDescBi.vue?vue&type=template&id=75999af0&scoped=true"
import script from "./stationDescBi.vue?vue&type=script&lang=js"
export * from "./stationDescBi.vue?vue&type=script&lang=js"
import style0 from "./stationDescBi.vue?vue&type=style&index=0&id=75999af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75999af0",
  null
  
)

export default component.exports